export default __webpack_public_path__ + "static/Image-Dr-Fulton-Headshot-988b144811d0de0c75ddc918fb77867a.jpg";